<div>
  <lib-app-skeleton
    #appSelectorComponent
    (onLogoutClick)="onLogout()"
    [appName]="appNameTitle"
    [displayedApp]="displayedApp"
    [logoRoute]=""
    [menu]="menu"
    [nameRoute]=""
    [onlySideMenuIcon]="onlySideMenuIcon"
    [urlRedirectionApp]="urlRedirectionApp"
    [userFirstname]="firstname"
    [userLastname]="lastname"
    [version]="version"
    [legalMentionRouterLink]="legalMentionRouterLink"
    [activiteAdherent]="activiteAdherent"
    [filialeAdherent]="filialeAdherent"
    [env]="env"
  >
  </lib-app-skeleton>
</div>
<app-progress-spinner></app-progress-spinner>
